module.exports = __webpack_public_path__ + "static/img/14003003.7b995568.png";